// 测试环境使用
if (window.location.hostname.includes('127.0.0.1')) {
  // 写入cookie
  function setCookie(name, value, options = {}) {
    const { expires, path, domain, secure } = options;
    let cookieString = `${name}=${value}`;
    if (expires) {
      cookieString += `; expires=${expires}`;
    }
    if (path) {
      cookieString += `; path=${path}`;
    }
    if (domain) {
      cookieString += `; domain=${domain}`;
    }
    if (secure) {
      cookieString += `; secure`;
    }
    document.cookie = cookieString;
  }
  setCookie(
    'momcozy-token',
    'eyJhbGciOiJIUzUxMiJ9.eyJ2cyI6IjEuMCIsInBsYXRGb3JtIjoiU0hPUElGWSIsImVtYWlsIjoibGluMTg0NTg3NTI5MkBnbWFpbC5jb20iLCJzdWIiOiIxOTEyNjgzOTM0OTI0Njc4MzMyIiwiYXVkIjoiR0VORVJJQyIsImV4cCI6MTc1MDk5ODI2OX0.dhtxC0sNqa5IeRdy1jk_l6MT4jT1Hg8tQ1JSyd1x4hljwSvNLhX_0eodLdHsA5SxqJ7cDkhWm_ycdhY9iuI4SA',
    {
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30),
      path: '/'
    }
  );
}

// 获取浏览器指纹
async function getBrowserFingerprint() {
  try {
    const fingerprint = await generateBrowserFingerprint();
    return fingerprint;
  } catch (error) {
    console.error('获取浏览器指纹失败:', error);
    return null;
  }
}

// 在yg-request.js中添加
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// 自动切换baseurl，// 测试环境使用
const BASE_URL = window.location.hostname.includes('momcozy')
  ? // ? 'https://lucky-name.momcozy.com/momcozy/webbackend/api/v1/'
    'https://lucky-name.momcozy.com/momcozy/webbackend/api/v1/'
  : 'https://lucky-name.momcozy.com/beta/momcozy/webbackend/api/v1/';
// 'http://192.168.132.18:5000/dev/momcozy/webbackend/api/v1/';

// 默认请求头
const DEFAULT_HEADERS = {
  'X-Session':
    'b24164776713d7eabc3657c6a753b604f2f79e3e1ba71d80c55a63fb1d5c9558111',
  'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100)
};

// 立即执行函数来使用await
(async function () {
  let localToken =
    'eyJhbGciOiJIUzUxMiJ9.eyJ2cyI6IjEuMCIsInBsYXRGb3JtIjoiU0hPUElGWSIsImVtYWlsIjoibGluMTg0NTg3NTI5MkBnbWFpbC5jb20iLCJzdWIiOiIxOTEyNjgzOTM0OTI0Njc4MzMyIiwiYXVkIjoiR0VORVJJQyIsImV4cCI6MTc1MDk5ODI2OX0.dhtxC0sNqa5IeRdy1jk_l6MT4jT1Hg8tQ1JSyd1x4hljwSvNLhX_0eodLdHsA5SxqJ7cDkhWm_ycdhY9iuI4SA';

  const fingerprint = await getBrowserFingerprint();
  DEFAULT_HEADERS['X-Session'] = fingerprint;
  DEFAULT_HEADERS['X-Scope'] = generateTime(
    (+new Date() + '').slice(0, -3),
    100
  );
  const token = getCookie('momcozy-token');
  console.log('cookie momcozy-token', token);
  if (token) {
    DEFAULT_HEADERS['Authorization'] = token;
  }
  if (window.location.hostname.includes('localhost')) {
    DEFAULT_HEADERS['Authorization'] = localToken;
  }
  console.log('DEFAULT_HEADERS~~~~~~~~~~', DEFAULT_HEADERS);
})();

// 请求函数
function YGCustomRequest({
  url,
  method = 'GET',
  data = null,
  params = null,
  headers = {}
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // 处理URL
    let finalUrl = /^https?:\/\//.test(url)
      ? url
      : BASE_URL + url.replace(/^\//, '');

    // 处理GET请求参数
    if (method === 'GET' && params) {
      const queryString = Object.entries(params)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');
      finalUrl = `${finalUrl}${
        finalUrl.includes('?') ? '&' : '?'
      }${queryString}`;
    }

    // 打开连接
    xhr.open(method, finalUrl, true);
    xhr.setRequestHeader('Cache-Control', 'no-cache');

    // 设置超时
    xhr.timeout = 30000; // 30秒超时
    xhr.ontimeout = () => reject({ status: 408, statusText: '请求超时' });

    // 合并请求头
    const finalHeaders = { ...DEFAULT_HEADERS, ...headers };
    for (const key in finalHeaders) {
      xhr.setRequestHeader(key, finalHeaders[key]);
    }

    // 处理响应
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (e) {
            resolve(xhr.responseText);
          }
        } else {
          reject({
            status: xhr.status,
            statusText: xhr.statusText,
            response: xhr.responseText
          });
        }
      }
    };

    // 错误处理
    xhr.onerror = () => reject({ status: 0, statusText: '网络错误' });

    // 发送请求
    if (method !== 'GET' && data) {
      if (typeof data === 'object' && data !== null) {
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data));
      } else {
        xhr.send(data);
      }
    } else {
      xhr.send();
    }
  });
}
// 获取GET请求
function YGCustomRequestGet(
  url,
  params = {},
  headers = {
    'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100)
  }
) {
  return YGCustomRequest({ url, method: 'GET', params, headers });
}
// 获取POST请求
function YGCustomRequestPost(
  url,
  data = {},
  headers = { 'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100) }
) {
  return YGCustomRequest({ url, method: 'POST', data, headers });
}
// 获取PUT请求
function YGCustomRequestPut(
  url,
  data = {},
  headers = { 'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100) }
) {
  return YGCustomRequest({ url, method: 'PUT', data, headers });
}
// 获取DELETE请求 params
function YGCustomRequestDelete(
  url,
  data = {},
  headers = { 'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100) }
) {
  return YGCustomRequest({ url, method: 'DELETE', data, headers });
}
// PATCH请求
function YGCustomRequestPatch(
  url,
  data = {},
  headers = { 'X-Scope': generateTime((+new Date() + '').slice(0, -3), 100) }
) {
  return YGCustomRequest({ url, method: 'PATCH', data, headers });
}
/**
 * 生成时间
 */
function generateTime(t, r) {
  return (
    r.toString(16) +
    (
      (((((t >> 24) & 0xff) ^ r) & 0x7f) << 24) +
      ((((t >> 16) & 0xff) ^ r) << 16) +
      ((((t >> 8) & 0xff) ^ r) << 8) +
      ((t & 0xff) ^ r)
    )
      .toString(16)
      .padStart(2, '0')
  );
}

/**
 * 生成浏览器唯一指纹
 * @returns {Promise<string>} 浏览器指纹哈希值
 */
async function generateBrowserFingerprint() {
  // 收集浏览器信息
  const components = [];

  // 用户代理
  components.push(navigator.userAgent);

  // 屏幕信息
  components.push(screen.width + 'x' + screen.height + 'x' + screen.colorDepth);

  // 时区偏移
  components.push(new Date().getTimezoneOffset());

  // 语言
  components.push(
    navigator.language || navigator.userLanguage || navigator.browserLanguage
  );

  // 已安装插件
  if (navigator.plugins) {
    const pluginsStr = Array.from(navigator.plugins)
      .map((p) => p.name + p.filename + p.description)
      .join(';');
    components.push(pluginsStr);
  }

  // 平台信息
  components.push(navigator.platform);

  // Cookie启用状态
  components.push(navigator.cookieEnabled);

  // localStorage可用性
  components.push(!!window.localStorage);

  // sessionStorage可用性
  components.push(!!window.sessionStorage);

  // Canvas指纹
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 50;

    // 绘制文本
    ctx.font = '20px Arial';
    ctx.fillStyle = 'rgb(100, 200, 300)';
    ctx.fillText('浏览器指纹', 10, 30);

    // 添加杂色
    ctx.fillStyle = 'rgb(200, 100, 50)';
    ctx.fillText('唯一标识', 10, 45);

    const canvasUrl = canvas.toDataURL();
    components.push(canvasUrl);
  } catch (e) {
    components.push('canvas-unsupported');
  }

  // WebGL信息
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (gl) {
      const renderer = gl.getParameter(gl.RENDERER);
      const vendor = gl.getParameter(gl.VENDOR);
      components.push(renderer + vendor);
    }
  } catch (e) {
    components.push('webgl-unsupported');
  }

  // 字体检测
  const fontList = [
    'Arial',
    'Times New Roman',
    'Courier New',
    'Verdana',
    'Georgia'
  ];
  const fontStr = fontList
    .filter((font) => {
      const testElement = document.createElement('span');
      testElement.style.fontFamily = font;
      return testElement.offsetWidth !== 0;
    })
    .join(',');
  components.push(fontStr);

  // 生成指纹字符串
  const fingerprintStr = components.join('###');

  // 使用SHA-256对指纹进行哈希
  // 注意：这里需要一个哈希函数，可以使用第三方库或Web Crypto API
  // 为简化示例，这里使用了简单的字符串哈希函数
  async function hashString(str) {
    if (window.crypto && window.crypto.subtle) {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    } else {
      // 简单哈希函数（生产环境建议使用更强的哈希算法）
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // 转为32位整数
      }
      return hash.toString(16);
    }
  }

  const hashDoname = await hashString('momcozy.com'); // b46761deb35ca5b0ff931a18c56f159541367d78948de1da3f497f22cea0610d
  const hashFingerprint = await hashString(fingerprintStr); // 2147737ac676736427eeb7d05a3bdc5857806d5c10ae8a13743fdcae48f1c5d1

  // b46761deb35ca5b0ff931a18c56f159541367d78948de1da3f497f22cea0610d2147737ac676736427eeb7d05a3bdc5857806d5c10ae8a13743fdcae48f1c5d1

  // ?s=xxxxx

  const result = mergeStrings(hashDoname, hashFingerprint);

  const resultHalf = result.substring(0, Math.floor(result.length / 2));

  // 返回哈希后的指纹
  // return result.substring(0, Math.floor(str.length / 2));

  return resultHalf;

  // return fingerprintStr;
}
// 合并字符串
function mergeStrings(str1, str2) {
  let result = '';
  const maxLength = Math.max(str1.length, str2.length);

  for (let i = 0; i < maxLength; i++) {
    if (i < str1.length) {
      result += str1[i];
    }
    if (i < str2.length) {
      result += str2[i];
    }
  }

  return result;
}
